import { Chip as MuiChip, useTheme } from '@mui/material';
import type { CSSProperties } from 'react';

interface ChipProps {
  label: string;
  color: CSSProperties['color'];
  textColor?: 'light' | 'dark';
  size: 'small' | 'medium'
}

const Chip = ({
  label,
  color,
  textColor = 'dark',
  size = 'small'
}: ChipProps) => {
  const theme = useTheme();
  return (
    <MuiChip
      label={label}
      size={size}
      sx={{
        color: textColor === 'light' ? theme.palette.primary.contrastText : theme.palette.primary.dark,
        backgroundColor: color,
      }}
    />
  );
};

export default Chip;